import { API_URL } from '@/constants/api';
import { readJson } from '@/shared/utils/json';
import type { BillingAttemptsResponse } from '../types';

export const fetchBillingAttempts = async (
  shopifyCustomerId: string,
  page: number = 1,
  perPage: number = 20,
): Promise<BillingAttemptsResponse> => {
  const response = await fetch(
    `${API_URL}/admin/customers/${shopifyCustomerId}/billing-attempts?page=${page}&perPage=${perPage}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        'Content-Type': 'application/json',
      },
    },
  );

  if (!response.ok) {
    throw new Error('Failed to fetch billing attempts');
  }

  return readJson<BillingAttemptsResponse>(response);
};
